export default () => '<div class="content">Choose if additional rail is required under modules.</div>';
